
import { useCallback } from 'react';

interface UseLoadingStateProps {
  setIsLoading: (isLoading: boolean) => void;
  setIsRetrying?: (isRetrying: boolean) => void;
  isRefreshingRef: React.MutableRefObject<boolean>;
  isMountedRef: React.MutableRefObject<boolean>;
}

export function useLoadingState({
  setIsLoading,
  setIsRetrying,
  isRefreshingRef,
  isMountedRef
}: UseLoadingStateProps) {
  // Reset all loading states
  const resetLoadingState = useCallback(() => {
    if (isMountedRef.current) {
      setIsLoading(false);
      if (setIsRetrying) {
        setIsRetrying(false);
      }
      // Only reset the refreshing flag here, after all operations are complete
      isRefreshingRef.current = false;
    }
  }, [setIsLoading, setIsRetrying, isRefreshingRef, isMountedRef]);

  // Set loading states at the start of an operation
  const startLoading = useCallback(() => {
    if (isMountedRef.current) {
      // Set the UI loading state
      setIsLoading(true);
      // Set the refresh flag to track that a fetch is in progress
      isRefreshingRef.current = true;
    }
  }, [setIsLoading, isRefreshingRef, isMountedRef]);

  return {
    resetLoadingState,
    startLoading
  };
}
